module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "ambis-meter"
    }
  }, [_c('v-breadcrumbs', {
    attrs: {
      "items": [{
          text: 'Dashboard',
          to: {
            path: '/'
          }
        },
        {
          text: 'Ambis Test'
        } ],
      "divider": "|"
    }
  }), _vm._v(" "), _c('h3', {
    staticClass: "header-text font-weight-bold"
  }, [_vm._v("Ambis Test")]), _vm._v(" "), _c('v-card', [_c('v-card-title', [_vm._v("\n            Daftar Tema Skala\n            "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "align-center text-body-2 blew white--text",
    attrs: {
      "depressed": ""
    },
    on: {
      "click": function($event) {
        return _vm.createAmbisTest()
      }
    }
  }, [_c('v-icon', {
    staticClass: "pr-2",
    attrs: {
      "small": ""
    }
  }, [_vm._v("mdi-plus-circle")]), _vm._v("\n                Tambah Tema Skala\n            ")], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('app-datatable', {
    key: _vm.tableKey,
    attrs: {
      "items": _vm.row,
      "headers": _vm.headers,
      "has-action": true,
      "has-edit": true,
      "has-leaderboard": true,
      "customWidth": true,
      "has-custom-pagination": true,
      "has-custom-search": true,
      "custom-pagination-total-items": _vm.total_data,
      "custom-pagination-current-page": _vm.pagination.currentPage,
      "custom-pagination-per-page": _vm.pagination.perPage,
      "custom-pagination-total-pages": _vm.pagination.totalPages,
      "custom-pagination-sort-mode": _vm.pagination.sortMode,
      "row-expanded-detail": _vm.row
    },
    on: {
      "selected": function($event) {
        _vm.selectedRow = $event
      },
      "dblClicked": function($event) {
        return _vm.detailTheme()
      },
      "changePage": function($event) {
        _vm.pagination = Object.assign({}, _vm.pagination,
          {currentPage: $event})
      },
      "changeSortMode": function($event) {
        _vm.pagination = Object.assign({}, _vm.pagination,
          {sortMode: $event})
      },
      "updateItem": function($event) {
        return _vm.editTheme()
      },
      "deleted": function($event) {
        return _vm.confirmDeleteItem($event)
      },
      "doSearch": function($event) {
        _vm.search = {
          query: $event.value,
          by: _vm.headersKey[$event.key],
        };
        _vm.doSearch();
      }
    }
  })], 1), _vm._v(" "), (_vm.isLoading) ? _c('app-spinner') : _vm._e(), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "persistent": "",
      "max-width": "450"
    },
    model: {
      value: (_vm.confirmDialog),
      callback: function($$v) {
        _vm.confirmDialog = $$v
      },
      expression: "confirmDialog"
    }
  }, [_c('dialog-confirm', {
    attrs: {
      "title": 'Hapus Tema Skala',
      "subtitle": 'Apakah anda akan menghapus Tema ini ?'
    },
    on: {
      "close": function($event) {
        _vm.confirmDialog = false
      },
      "confirm": function($event) {
        return _vm.deleteItem()
      }
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4ec50015","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/ambis_test/components/AmbisTest.vue
// module id = 998
// module chunks = 1